export default __webpack_public_path__ + "static/media/app_store.bdff199c.jpg";